import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeteringPointType } from './types';

export const meteringPointTypeApi = createApi({
  reducerPath: 'meteringPointTypeApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-point-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringPointsTypes: builder.query<MeteringPointType[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetMeteringPointsTypesQuery } = meteringPointTypeApi;
